import { Sdk } from "@/core/sdk";
import { FloatingPlugin } from "@/plugins/floating";
import { MessagePlugin } from "@/plugins/message";
import { TrackerPlugin } from "@/plugins/tracker";

import "./index.scss";

declare global {
  interface Window {
    $hz: Sdk;
  }
}

const $hz = new Sdk();
window.$hz = $hz;

$hz.setPlugins({
  imports: [FloatingPlugin, TrackerPlugin, MessagePlugin],
  requires: [
    {
      source: FloatingPlugin,
      deep: [TrackerPlugin],
    },
  ],
});

// const svg = `
//   <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
//     <path d="M442.688 163.84l-288 720A100.48 100.48 0 0 1 61.44 745.984l228.096-570.24a19.136 19.136 0 0 1 17.728-12.032h135.424z" p-id="18767" fill="#d81e06"></path>
//     <path d="M604.16 504.128L480.256 192.192a44.992 44.992 0 0 0-41.792-28.416H320.576l135.232 340.352h148.416zM861.632 578.368h-148.352l122.176 305.408a100.48 100.48 0 0 0 93.248-137.728l-67.072-167.68zM632 572.032H483.648l150.528 311.744a93.12 93.12 0 0 0 83.84-133.568L632 572.032z" p-id="18768" fill="#d81e06"></path>
//     <path d="M692.032 698.56a196.096 196.096 0 0 0-183.36-126.528h-50.112a126.528 126.528 0 0 0-126.592 126.528h360zM842.24 264.128l27.328 4.16c3.84 0.64 7.296 2.624 9.728 5.696l17.344 21.568a15.552 15.552 0 0 0 27.52-7.36l4.224-27.392c0.576-3.84 2.56-7.296 5.568-9.728l21.568-17.28a15.552 15.552 0 0 0-7.36-27.52l-27.328-4.288a15.616 15.616 0 0 1-9.728-5.568l-17.344-21.568a15.552 15.552 0 0 0-27.52 7.36l-4.224 27.328a15.552 15.552 0 0 1-5.568 9.728l-21.632 17.344a15.488 15.488 0 0 0-0.64 23.68 15.616 15.616 0 0 0 8 3.84zM701.952 173.376l-33.28-5.12a18.88 18.88 0 0 1-8.96-33.408l26.24-21.12a18.752 18.752 0 0 0 6.848-11.776l5.12-33.28a18.88 18.88 0 0 1 33.408-8.96l21.12 26.24a18.88 18.88 0 0 0 11.776 6.848l33.28 5.12c16.128 2.56 21.696 23.104 8.896 33.408l-26.24 21.056a18.88 18.88 0 0 0-6.784 11.84l-5.12 33.216a18.88 18.88 0 0 1-33.408 8.96l-21.12-26.24a18.88 18.88 0 0 0-11.776-6.784zM638.272 457.984l60.032 9.28c8.448 1.28 16 5.76 21.376 12.352l38.016 47.36c18.56 23.04 55.744 13.12 60.288-16.192l9.28-60.032a33.984 33.984 0 0 1 12.352-21.312l47.36-38.08a34.112 34.112 0 0 0-16.192-60.224l-60.032-9.28a34.048 34.048 0 0 1-21.312-12.352l-38.08-47.36a34.112 34.112 0 0 0-60.288 16.192l-9.28 60.032a34.048 34.048 0 0 1-12.288 21.312l-47.36 38.08c-23.04 18.56-13.12 55.68 16.128 60.224z" p-id="18769" fill="#d81e06"></path>
//   </svg>
// `;
//
// void $hz
//   .init({
//     appId: "dddd",
//     // floating: {
//     //   icon: svg,
//     //   url: "",
//     // },
//     track: {
//       autoPage: true,
//     },
//   })
//   .then(({ sdk }) => {
//     console.log(sdk);
//     sdk.plugins.getPluginByName("FloatIng");
//
//     // 类型安全：自动推断为 MessagePlugin | undefined
//     // 无需指定泛型参数 <MessagePlugin>
//     const message = sdk.plugins.getPluginByName("Message");
//     if (message != undefined) {
//       message.onMessage<string>((o) => {
//         console.log(o);
//       });
//     }
//   });

export default $hz;
